import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import ReactPlayer from 'react-player/youtube';
import { Image, Input, Spin, Tag, Select, Modal } from 'antd';
import moment from 'moment';
import { AiOutlineLike, AiOutlineEye, AiOutlinePlayCircle } from 'react-icons/ai';
import { MdKeyboardVoice } from 'react-icons/md';
import { LoadingOutlined } from '@ant-design/icons';
import { BiTime, BiSort, BiArrowBack } from 'react-icons/bi';
import { BsSearch } from 'react-icons/bs';
import { RiShareForwardLine } from 'react-icons/ri';
import InfiniteScroll from 'react-infinite-scroll-component';
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import {
  WhatsappShareButton,
  WhatsappIcon,
  LinkedinShareButton,
  LinkedinIcon,
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
} from 'react-share';
import {
  getVideosFromCache,
  getTopVideoTags,
  searchVideos,
  getSearchSuggestions,
} from '../../services/API/ContentVideoService';
import '../../styles/components/ContentVideo/ContentVideo.scss';
import ScreenNavigation from '../Marketplace/ScreenNavigation';
import { DEFAULT_VIDEO_COUNT } from '../../constants/MarketplaceConstants';
import useMoengage from '../../hooks/useMoengage';
import { useMitraStore } from '../../contexts/MitraContext';

const formatNumberToKFormat = value => {
  const formatter = Intl.NumberFormat('en-IN', { notation: 'compact' });
  return formatter.format(value);
};

const VideoData = ({ data, playingVideo = false, fontSize = '10px', marginLeft = '15px' }) => {
  const [share, setShare] = useState(false);
  return (
    // <div className={playingVideo ? 'playingVideoData' : 'videoData'}>
    <div className="videoData" style={{ fontSize, marginLeft }}>
      <h6 className={playingVideo ? 'playingVideoDataHeading' : 'videoDataHeading'}>
        {data?.title}
      </h6>
      <div
        className={playingVideo ? 'videoDataStatsContainerPlaingVideo' : 'videoDataStatsContainer'}
      >
        <div className="videoDataStats">
          <p>
            <AiOutlineEye /> {formatNumberToKFormat(data?.viewCount)} Views
          </p>
          <p>
            <BiTime /> {moment(data?.publishedAt).fromNow()}
          </p>
        </div>
        <div className="videoDataStats">
          <p>
            <AiOutlineLike /> {formatNumberToKFormat(data?.likeCount)} likes{' '}
          </p>
          <p onClick={() => setShare(true)}>
            <RiShareForwardLine /> Share
          </p>
          {share && <ShareVideo open={share} close={() => setShare(false)} data={data} />}
        </div>
      </div>
    </div>
  );
};

const VideoComponent = ({ data, callback }) => {
  return (
    <div className="videoContainer">
      <img
        src={data?.thumbnail}
        className="videoImage"
        onClick={callback}
        alt="Mitra Jobs Marketplace"
      />
      <VideoData data={data} />
    </div>
  );
};

const VideoTags = ({ tag, selected, callback }) => {
  return (
    <Tag
      style={{
        color: selected ? '#FFFFFF' : '#000',
      }}
      className="videoTag"
      color={selected ? '#000' : '#E9ECEE'}
      onClick={callback}
    >
      {tag}
    </Tag>
  );
};

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const ContentVideo = () => {
  const query = useQuery();
  const entryType = query.get('entryType');

  const [pageEntryType] = useState(entryType && entryType !== '' ? entryType : '');
  const [loading, setLoading] = useState(true);
  const [videoData, setVideoData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [searchResultFound, setSearchResultFound] = useState(true);
  const [topTags, setTopTags] = useState(['All']);
  const [watchedVideos, setWatchedVideos] = useState([]);
  const [searchSuggestions, setSearchSuggestions] = useState([]);
  const [sortBy, setSortBy] = useState('');
  const [offset, setOffset] = useState(0);
  const [, trackEvent] = useMoengage();
  const { selectedMitraDetails } = useMitraStore();

  const getVideosCache = (prop = '') => {
    const videoCacheApiObj = {
      offset: prop !== sortBy && prop !== '' ? 0 : offset,
      sortBy: prop || sortBy,
    };

    getVideosFromCache(videoCacheApiObj)
      .then(response => {
        if (response.status === 200) {
          return response.data;
        }
        setLoading(false);
      })
      .then(responseObj => {
        setLoading(false);
        setVideoData(
          prop !== sortBy && prop !== '' ? responseObj?.data : videoData.concat(responseObj?.data)
        );
        setSearchData(
          prop !== sortBy && prop !== '' ? responseObj?.data : searchData.concat(responseObj?.data)
        );
        setOffset(offset + 1);
        setSortBy(prop);
      })
      .catch(error => {
        // console.log(error);
        setLoading(false);
      });
  };

  const sortStatictics = prop => {
    getVideosCache(prop);
  };

  const findTopTags = () => {
    getTopVideoTags()
      .then(response => {
        if (response?.status === 200) {
          return response?.data;
        }
        throw response?.data?.error;
      })
      .then(responseObj => {
        const tags = responseObj?.data;
        setTopTags(tags);
      })
      .catch(error => {
        console.log(error);
      });
  };

  useEffect(() => {
    getVideosCache();
    findTopTags();
    const startTime = performance.now();  
    return () => {
      trackEvent('jse_total_time_spend_on_videos_in_sec', 
      {
        spentDuration: performance.now()-startTime, 
        userId: localStorage.getItem('userId'),
        userPhoneNumber: selectedMitraDetails?.userPhoneNumber, 
        timeStamp: moment().format('MM/DD/YYYY HH:mm:ss') 
      });
    }
  }, []);

  const { transcript, resetTranscript } = useSpeechRecognition();

  const searchVideo = (defSearch = '', fromTopTags = false) => {
    const search = defSearch === '' ? searchText : defSearch;

    // add event here
    trackEvent('jse_search_bar_used', 
    {
      userId: localStorage.getItem('userId'), 
      searchText: search, 
      userPhoneNumber: selectedMitraDetails?.userPhoneNumber, 
      timeStamp: moment().format('MM/DD/YYYY HH:mm:ss') 
    });

    searchVideos({ searchText: search, offset: 0 })
      .then(response => {
        if (response?.status === 200) {
          return response?.data;
        }
        throw response?.data?.error;
      })
      .then(responseObj => {
        const searchFoundVideos = responseObj?.data;
        const removedPlayedVideoData = videoData.filter(function(item) {
          return !watchedVideos.includes(item?.youtubeVideoId);
        });
        setSearchData(
          searchFoundVideos.length === 0 || search === 'All'
            ? removedPlayedVideoData
            : searchFoundVideos
        );

        setSearchText(fromTopTags ? '' : search);

        if (search === 'All' || searchFoundVideos.length > 0) setSearchResultFound(true);
        else if (searchFoundVideos.length === 0 && search !== '') setSearchResultFound(false);

        if (!fromTopTags) {
          setSelectedTag('All');
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  const handleChange = e => {
    setSearchText(e.target.value);
    setPlayingVideo(false);
    if (e.target.value === '') {
      setSearchData(videoData);
      setSearchResultFound(true);
    }
  };

  const [selectedTag, setSelectedTag] = useState('All');

  const handleTagClick = tag => {
    trackEvent('jse_video_tag_used', 
    {
      userId: localStorage.getItem('userId'), 
      tagName: tag, 
      userPhoneNumber: selectedMitraDetails?.userPhoneNumber, 
      timeStamp: moment().format('MM/DD/YYYY HH:mm:ss')
    });
    setSelectedTag(tag);
    setPlayingVideo(false);
    setIsTyping(false);
    searchVideo(tag, true);
    resetTranscript();
  };

  const voiceSearch = text => {
    console.log('inside voice search: ', text);
    if (text && text !== '') {
      setSelectedTag('All');
      searchVideo(text);
    }
  };

  const [playingVideo, setPlayingVideo] = useState(false);
  const [playingVideoId, setPlayingVideoId] = useState('');
  const [playingVideoData, setPlayingVideoData] = useState({});

  const handlePlayVideo = (videoId, playVideoData) => {
    setPlayingVideoId(videoId);
    setPlayingVideoData(playVideoData);
    setPlayingVideo(true);
    setIsTyping(false);
    watchedVideos.push(videoId);
    setWatchedVideos(watchedVideos);
    const removedPlayedVideoData = searchData.filter(function(item) {
      return !watchedVideos.includes(item?.youtubeVideoId);
    });
    setSearchData(removedPlayedVideoData);
    window.scrollTo(0, 0);
  };

  const [isTyping, setIsTyping] = useState(false);

  const handleInputClick = () => {
    // const suggestions = [];
    // const processedSuggestions = new Set();
    // topTags.slice(5, 10).map(tag => {
    //   for (const data of videoData) {
    //     if (data?.tags && !processedSuggestions.has(data?.id)) {
    //       if (data?.tags.includes(tag)) {
    //         suggestions.push({ data, tag });
    //         processedSuggestions.add(data?.id);
    //         break;
    //       }
    //     }
    //   }
    // });

    getSearchSuggestions()
      .then(response => {
        if (response?.status === 200) {
          return response?.data;
        }
      })
      .then(responseObj => {
        setSearchSuggestions(responseObj?.data);
      })
      .catch(error => {
        console.log(error);
      });

    setIsTyping(true);
  };

  return (
    <div style={{ paddingBottom: '80px' }}>
      <div className="mainContainer">
        <div className="header">
          {/* <SearchTag callback={() => voiceSearch(transcript)} /> */}
          <InputField
            callback={handleChange}
            onclick={handleInputClick}
            typing={isTyping}
            onkeydown={e => (e.key === 'Enter' ? (searchVideo(searchText), setIsTyping(false)) : 1)}
          />
          <PageHeading typing={isTyping} />
          {isTyping && (
            <BiArrowBack
              size="2em"
              style={{ marginRight: '10px' }}
              onClick={() => setIsTyping(false)}
            />
          )}
        </div>
        <div className="videoTags">
          {topTags.map(tag => (
            <VideoTags
              tag={tag}
              key={tag}
              selected={tag === selectedTag}
              callback={() => handleTagClick(tag)}
            />
          ))}
        </div>
        {!loading && playingVideo && (
          <PlayYoutubeVideo videoId={playingVideoId} data={playingVideoData} />
        )}
        {!isTyping && (
          <div className="videoSortBy">
            <h5 className="allVideosHeading">
              {transcript && transcript.length !== 0 && searchResultFound
                ? `Showing results for: ${transcript}`
                : searchText && searchText.length !== 0 && searchResultFound
                ? `Showing results for: ${searchText}`
                : 'All Videos'}
            </h5>
            <SelectSortBy callback={sortStatictics} />
          </div>
        )}
        {/* </div> */}
        {!loading && !searchResultFound && !isTyping && (
          <h6 className="noVideoFound">0 Results Found. Showing Suggested Videos. </h6>
        )}
        {!isTyping && (
          <div>
            <InfiniteScroll
              dataLength={videoData.length}
              hasMore
              loader={
                <LoadingOutlined
                  style={{ fontSize: 24, display: 'flex', justifyContent: 'center' }}
                  spin
                />
              }
              next={getVideosCache}
            >
              {!loading &&
                searchData.map((data, index) => (
                  <VideoComponent
                    key={`${data?.id}${index}`}
                    data={data}
                    callback={() => { 
                      trackEvent('jse_video_clicked', 
                      {
                        userId: localStorage.getItem('userId'), 
                        videoData: data?.title,
                        userPhoneNumber: selectedMitraDetails?.userPhoneNumber, 
                        timeStamp: moment().format('MM/DD/YYYY HH:mm:ss') 
                      });
                      handlePlayVideo(data?.youtubeVideoId, data)}}
                  />
                ))}
              {loading && <Spin spinning={loading} className="spinner" tip="Loading" />}
            </InfiniteScroll>
          </div>
        )}
        {isTyping && <SearchSuggestions data={searchSuggestions} callback={handlePlayVideo} />}
      </div>
      {pageEntryType !== 'dynamic' && <ScreenNavigation />}
    </div>
  );
};

const SearchSuggestions = ({ data, callback }) => {
  return (
    <div className="searchSuggestions">
      <hr />
      <h6 className="searchSuggestionsHeading">Search Suggestions</h6>
      {data.map(item => (
        <div key={item?.id} className="searchSuggestionsItemContainer">
          <p className="searchSuggestionsItem" onClick={() => callback(item?.youtubeVideoId, item)}>
            {item?.tag}
          </p>
          <AiOutlinePlayCircle
            size="1em"
            style={{ flexShrink: '0' }}
            onClick={() => callback(item?.youtubeVideoId, item)}
          />
        </div>
      ))}
    </div>
  );
};

const SelectSortBy = ({ callback }) => {
  const [, trackEvent] = useMoengage();
  const { selectedMitraDetails } = useMitraStore();
  const handleChange = value => {
    console.log(`selected ${value}`);
    trackEvent('jse_sort_by_used', 
    {
      userId: localStorage.getItem('userId'),
      userPhoneNumber: selectedMitraDetails?.userPhoneNumber, 
      timeStamp: moment().format('MM/DD/YYYY HH:mm:ss') 
    });
    callback(value);
  };
  return (
    <Select
      defaultValue="Sort By"
      className="selectSortBy"
      bordered={false}
      dropdownStyle={{
        fontSize: '8px',
      }}
      suffixIcon={<BiSort />}
      onChange={handleChange}
      options={[
        {
          value: 'likeCount',
          label: 'Most Liked',
        },
        {
          value: 'viewCount',
          label: 'Most Viewed',
        },
        {
          value: 'publishedAt',
          label: 'Most Recent',
        },
      ]}
    />
  );
};

const InputField = ({ callback, typing, onclick, onkeydown }) => {
  const { transcript } = useSpeechRecognition();

  return (
    <Input
      style={{
        width: typing ? '100%' : '60%',
      }}
      className="searchInputBox"
      type="search"
      placeholder="Search..."
      onChange={callback}
      onClick={onclick}
      onKeyDown={onkeydown}
      suffix={<BsSearch />}
    />
  );
};

const PageHeading = ({ typing }) => {
  return (
    <p
      style={{
        display: typing ? 'none' : 'block',
      }}
      className="pageHeading"
    >
      Videos{' '}
    </p>
  );
};

const VoiceModal = ({ title, open, close }) => {
  return (
    <Modal open={open} onCancel={close} closable={false} footer={null} maskClosable>
      <h6>{title === '' ? 'Listening ...' : title}</h6>
      <div className="voiceModal">
        <Image src="https://www.ubermetrics-technologies.com/wp-content/uploads/VOICE.gif" />
      </div>
    </Modal>
  );
};

const SearchTag = ({ callback }) => {
  const [voice, setVoice] = useState(false);

  const { transcript, listening } = useSpeechRecognition();

  const handleClick = () => {
    const speech = SpeechRecognition.startListening();
    setVoice(true);
  };
  return (
    <>
      <Tag
        className="voiceSearchContainer"
        onTouchStart={handleClick}
        onTouchEnd={(() => setVoice(false), callback)}
        onTouchCancel={() => setVoice(false)}
        onMouseLeave={() => setVoice(false)}
        icon={<MdKeyboardVoice />}
      />
      <VoiceModal
        open={voice && listening}
        close={() => {
          setVoice(false);
        }}
        title={transcript}
      />
    </>
  );
};

const PlayYoutubeVideo = ({ videoId, data }) => {
  return (
    <div style={{ marginTop: '20px' }}>
      <ReactPlayer
        url={`https://www.youtube.com/watch?v=${videoId}&rel=0`}
        width="100%"
        height="200px"
        controls
        loop
        playing
      />
      <VideoData data={data} fontSize="14px" marginLeft="0px" playingVideo="true" />
      <hr className="hrLine" />
    </div>
  );
};

const ShareVideo = ({ open, close, data }) => {
  const SHARE_MSG = `Watch this video on the Vahan Mitra App - ${data?.title}\n\n`;
  const MITRA_APP_LINK = 'https://mitraapp.page.link/playstore';
  return (
    <Modal
      onCancel={close}
      onOk={close}
      open={open}
      title="Share Video"
      closable={false}
      footer={null}
      maskClosable
    >
      <div className="shareVideoContainer">
        <WhatsappShareButton title={SHARE_MSG} url={MITRA_APP_LINK}>
          <WhatsappIcon />
        </WhatsappShareButton>
        <LinkedinShareButton title={SHARE_MSG} url={MITRA_APP_LINK}>
          <LinkedinIcon />
        </LinkedinShareButton>
        <FacebookShareButton title={SHARE_MSG} url={MITRA_APP_LINK}>
          <FacebookIcon />
        </FacebookShareButton>
        <TwitterShareButton title={SHARE_MSG} url={MITRA_APP_LINK}>
          <TwitterIcon />
        </TwitterShareButton>
      </div>
    </Modal>
  );
};

export default ContentVideo;
